<template>
    <VoidClaim :Type="AppServiceID"></VoidClaim>
</template>
<script>
import VoidClaim from '@/components/Common/VoidClaim.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
         AppServiceID :'', 
        }
    },
 components: {
    VoidClaim  : VoidClaim
        },
   created: function() {
      this.AppServiceID= this.$store.getters.GetPodiatryID;
       //console.log('at created' + this.AppServiceID)
      this.$emit('update:layout', LayoutDefault);
    },
    beforeCreate: function() {  
        this.$store.dispatch('AddServiceID',this.$store.getters.GetPodiatryID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetPodiatryID); 
    },
}
</script>
